import React, { useState } from 'react';
import { Box, PrimaryButton } from '@stashinvest/ui';
import { Drawer } from '@stashinvest/ui/dist/es/2';
import { BanjoString } from '@stashinvest/react-banjo';
import { LegalString, LegalStringColor, Text } from '@stashinvest/react-components';

export const LearnMorePlaidDataSharing = () => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<Text
				tag="button"
				textStyle="bodyMediumLink"
				onClick={() => {
					setOpen(true);
				}}
			>
				<BanjoString stringId="action/explore/learnMoreDataUsage" />
			</Text>
			{open && (
				<Drawer onDismiss={() => setOpen(false)}>
					{({ closeDrawer }) => (
						<Box p="s24" pb="0">
							<Text
								textStyle="headerSmall"
								textAlign="center"
								className="my-contentSmall"
							>
								<BanjoString stringId="information/giveTerm/plaidDataUsage" />
							</Text>
							<LegalString className="mb-layoutSmall" color={LegalStringColor.inverse}>
								<BanjoString
									stringId="information/disclose/plaidStashLinkBankData"
									openLinksInNewWindow={true}
								/>
							</LegalString>
							<PrimaryButton onClick={closeDrawer}>
								<BanjoString stringId="action/escape/goBack" />
							</PrimaryButton>
						</Box>
					)}
				</Drawer>
			)}
		</>
	);
};

export default LearnMorePlaidDataSharing;
